import React from 'react';
import { TextButton, TextButtonPriority } from '@wix/wix-ui-tpa/cssVars';
import { SparklesFilled } from '@wix/wix-ui-icons-common';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useSidebarLayoutBase } from '../../contexts/SidebarLayoutBase/SidebarLayoutBaseContext';
import { AiTutorUserEntry } from '../../../../../../../contexts/main/biInterfaces';
import { useSettings } from '@wix/tpa-settings/react';
import challengeSettings from '../../../../../settingsParams';

import { classes, st } from './AiChatButton.st.css';

export const AiChatButton: React.FC = () => {
  const { toggleAiChatVisibility, isAiChatVisible, isAiChatEnabled } =
    useSidebarLayoutBase();
  const settings = useSettings();
  const { isMobile } = useEnvironment();
  const title = settings.get(challengeSettings.aiTitleTxt);

  if (!isAiChatEnabled || isAiChatVisible) {
    return null;
  }

  return (
    <TextButton
      className={st(classes.root, {
        mobile: isMobile,
      })}
      priority={TextButtonPriority.secondary}
      prefixIcon={<SparklesFilled className={classes.aiChatIcon} />}
      onClick={() => toggleAiChatVisibility(AiTutorUserEntry.TopControls)}
    >
      {title as string}
    </TextButton>
  );
};
